import { Component, OnDestroy, OnInit, signal, TemplateRef, viewChild } from '@angular/core';
import { CarouselArrowsComponent } from 'src/app/home-page/components/carousel-arrows/carousel-arrows.component';
import { SectionTitleComponent } from 'src/app/home-page/components/section-title/section-title.component';
import { CarouselBaseComponent } from 'src/app/home-page/components/carousel-base/carousel-base.component';
import { CarouselService } from '../../services/carousel.service';
import { ProductCardComponent } from '@core/components/product-card/product-card.component';
import { Subscription } from 'rxjs';
import { Product } from '@core/models/piramide/Product';
import { CarouselItemBase } from 'src/app/home-page/components/carousel-base/carousel-item-base.model';
import { SwiperOptions } from 'swiper/types';
import { CAROUSEL_BASE_DEFAULT_CONFIG } from 'src/app/home-page/components/carousel-base/carousel-base.default-config';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cgw-offers-section',
  standalone: true,
  imports: [
    SectionTitleComponent,
    CarouselArrowsComponent,
    CarouselBaseComponent,
    ProductCardComponent,
    CommonModule,
  ],
  templateUrl: './offers-section.component.html',
  styleUrl: './offers-section.component.scss',
})
export class OffersSectionComponent implements OnInit, OnDestroy {
  private readonly _productTemplateRef = viewChild('productTemplate', { read: TemplateRef });

  public readonly carousel =
    viewChild<CarouselBaseComponent<Product, CarouselItemBase<Product>>>(CarouselBaseComponent);
  public readonly carouselConfig = signal<SwiperOptions>({
    ...CAROUSEL_BASE_DEFAULT_CONFIG,
    slidesPerView: 1.5,
    spaceBetween: 10,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });
  public readonly carouselItems = signal<CarouselItemBase<Product>[]>([]);
  public readonly showOffers = signal<boolean>(false);
  private offersSubscription$: Subscription;

  constructor(private carouselService: CarouselService) {}

  public ngOnInit(): void {
    this.offersSubscription$ = this.carouselService.getOffers().subscribe((offers) => {
      this.carouselItems.set(
        (offers.productos as Product[]).map(
          (p) =>
            new CarouselItemBase({
              id: p.id_producto,
              data: p,
              templateRef: this._productTemplateRef(),
              templateContext: { item: p },
            }),
        ),
      );
      this.showOffers.set(!!offers.configura && this.carouselItems().length > 0);
    });
  }

  public ngOnDestroy(): void {
    this.offersSubscription$?.unsubscribe();
  }
}
